import { Box, styled } from '@/theme/index';

export const MainImgContainer = styled(Box)(({ theme }) => ({
  width: '405px',
  display: 'none',
  background: 'center / contain no-repeat',
  objectFit: 'contain',

  [theme.breakpoints.up('md')]: {
    display: 'block',
  },
}));

export const ArrowImgContainer = styled(Box)(({ theme }) => ({
  position: 'absolute',
  right: 0,
  top: 0,

  width: 60,
  height: 60,
  marginRight: theme.spacing(1.25),
  marginTop: theme.spacing(0.5),
  background: 'center / contain no-repeat',

  [theme.breakpoints.up(500)]: {
    marginRight: theme.spacing(2),
    marginTop: theme.spacing(-2.25),
  },

  [theme.breakpoints.up('md')]: {
    display: 'none',
  },
}));
